import React from "react";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";

interface PhoneFieldProps {
  label?: string;
  onChange?: (value: string) => void;
  value?: string;
  maxLength?: number;
}

const PhoneField: React.FC<PhoneFieldProps> = ({
  label,
  onChange,
  value,
  maxLength,
}) => {
  return (
    <div className="flex flex-col gap-[5px] w-full">
      {label && (
        <label htmlFor="" className="text-base tracking-[0.16px] text-black">
          {label}
        </label>
      )}

      <PhoneInput
        country="ng"
        value={value}
        placeholder="Enter phone number"
        containerClass="border border-[#969696] p-[12px_0px_12px_12px] bg-[#F8FAFC] rounded-lg"
        onChange={(value) => onChange?.(value)}
        inputStyle={{
          border: "none",
          height: "inherit",
          width: "100%",
          backgroundColor: "transparent",
        }}
        buttonStyle={{
          border: "none",
        }}
        inputProps={{
          maxLength: maxLength ?? 17,
        }}
      />
    </div>
  );
};

export default PhoneField;
